/// <reference path="../lib/jquery.d.ts" />

export class ResourcesControl {

    private linkCards: JQuery = $('.linkCardHolder .linkCard');
    private loadMore: JQuery = $('#loadMore');
    private showLess: JQuery = $('#showLess');
    private listSize: number;
    private cardChunk: number;
    private noToShow: number;
    
    constructor() {

        this.listSize = $(this.linkCards).length;
        this.noToShow = 6
        this.cardChunk = this.noToShow;
        
        
        $('.linkCardHolder .linkCard:lt('+this.cardChunk+')').show();

        if (this.listSize < this.noToShow)
        {
            $(this.loadMore).parent().hide();
        }

        this.loadMore.parent().on('click', (e)=>{
            this.cardChunk = (this.cardChunk+this.noToShow <= this.listSize) ? this.cardChunk+this.noToShow : this.listSize;

            // console.debug("show" + this.cardChunk)

            $('.linkCardHolder .linkCard:lt('+this.cardChunk+')').show();

            if (this.cardChunk >= this.listSize)
            {
                $(this.loadMore).parent().hide();
            }
        });
        
        
    }
    

}